import { render, staticRenderFns } from "./SaveMessage.vue?vue&type=template&id=324a918b"
import script from "./SaveMessage.vue?vue&type=script&lang=js"
export * from "./SaveMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports